export default "__VITE_ASSET__Bff0jLZh__"